import { Component, OnInit, Inject } from '@angular/core';
import { AccountService } from '../../../../../services/account.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CorporateService } from 'src/app/services/corporate.service';

@Component({
  selector: 'app-add-addon-dialogg',
  templateUrl: './add-addon-dialogg.component.html',
  styleUrls: ['./add-addon-dialogg.component.css']
})
export class AddAddonDialoggComponent implements OnInit {
  api_error: any;
  addondisply: any;
  api_success: string;
  addons: any = [];
  addonname: any = [];
  disableConfirmbtn = false;
  description: string;
  addondisplyy: string;
  addonIds: string;
  type: any;
  metricName: any = [];
  addonsList: any = [];
  addons_conf;
  constructor(
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private accountService: AccountService,
    private corporateService: CorporateService) { 
      
    }
  ngOnInit() {
    this.addondisply = ['Cloud Storage'];
    this.type = this.data['type'];
    this.accountService.getupgradableAddons()
      .subscribe(res => {
        let addons_applied = [];
        // let addons_conf: any = [];
        addons_applied = this.data['addon'];
        this.addons_conf = res;
        for (let j = 0; j < this.addons_conf.length; j++) {
          for (let k = 0; k < this.addons_conf[j].addons.length; k++) {
            if (!this.isAddonExists(this.addons_conf[j].addons[k], addons_applied)) {
              this.addons.push(this.addons_conf[j].addons[k]);
            }
          }
        }
        for (let disply of this.addons_conf) {
          this.metricName.push(disply.metricDisplayName);
        }
        // let name = '';
        // addons_conf = res;
        // for (let i = 0; i < this.addons_conf.length; i++) {
        //     name = this.addons_conf[i].metricDisplayName;
        //     break;
        // }
        // console.log(name);
      });
  }
  isAddonExists(addon, addons_applied) {
    let isexists = false;
    if (this.data['type'] === 'account') {
      for (let i = 0; i < addons_applied.length; i++) {
        if (addons_applied[i].licPkgOrAddonId === addon.addonId) {
          isexists = true;
        }
      }
    } else if (this.data['type'] === 'corporate') {
      for (let i = 0; i < addons_applied.length; i++) {
        if (addons_applied[i].addonId === addon.addonId) {
          isexists = true;
        }
      }
    }
    return isexists;
  }
  addonClick(addondisply) {
    const metriclist = this.addons_conf.filter(addon => (addon.metricDisplayName === addondisply));
    this.addonsList = metriclist[0].addons;
  }

  onChange(addonList) {
    let addonDesc = '';
    let addonId = '';
    addonList.forEach((e1) => this.addons.forEach((e2) => {
      if (e1 === e2.addonId) {
        if (addonDesc !== '') {
          addonDesc = addonDesc + ',' + e2.addonDesc;
          addonId = addonId + ',' + e2.addonId;
        } else {
          addonDesc = e2.addonDesc;
          addonId = e2.addonId;
        }
      }
    }));
    this.description = addonDesc;
    this.addonIds = addonId;
  }
  onChangeCorporateAddon(addonlist) {
    console.log('addonId......' + addonlist);
    this.addons.forEach((e2) => {
      // tslint:disable-next-line:triple-equals
      if (addonlist == e2.addonId) {
        this.description = e2.addonDesc;
        this.addonIds = addonlist;
        console.log('description........' + e2.addonDesc);
      }
    });
  }
  submitAddon() {
    this.api_error = '';
    this.api_success = '';
    console.log('addons..' + this.addonIds);
    if (this.addonIds === '' || this.addonIds === 'undefined') {
      this.api_error = 'please select addon';
    } else {

      this.disableConfirmbtn = true;
      if (this.data['type'] === 'account') {
        const data = {
          accountId: this.data['accountId'],
          addonIds: this.addonIds
        };
        this.accountService.addAddons(data)
          .subscribe(
            res => {
              this.api_success = 'Addon added Successfully';
              setTimeout(() => {
                this.dialogRef.close('reloadlist');
              }, 2000);
            },
            (error) => {
              this.api_error = error.error;
              this.disableConfirmbtn = false;
            }
          );
      } else if (this.data['type'] === 'corporate') {
        this.corporateService.addAddon(this.data['corpId'], this.addonIds)
          .subscribe(
            res => {
              this.api_success = 'Addon added Successfully';
              setTimeout(() => {
                this.dialogRef.close('reloadlist');
              }, 2000);
            },
            (error) => {
              this.api_error = error.error;
              this.disableConfirmbtn = false;
            }
          );
      }
    }
  }
  public closeDialog() {
    this.dialogRef.close();
  }
}